<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>

    <v-row justify="center">
      <v-dialog
        v-model="selctedItemsPopup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="v-card-100 mt-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title
              >Selected {{ selected_table_data.length }} Items</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn
                class="text-blue bg-white text-none"
                size='small' 
                @click="assignExecutiveFnc"
                >Assign Executive</v-btn
              >
              <v-btn
                class="ml-2 text-blue bg-white text-none"
                size='small'
                @click="addMoreItems"
                >Add More Items</v-btn
              >
              <v-btn
                class="ml-2 text-red bg-white text-none"
                size='small'
                @click="deleteRequest"
                >Delete Request</v-btn
              >
              <v-btn icon dark @click="selctedItemsPopup = false"
                ><v-icon color="white">mdi-close</v-icon></v-btn
              >
            </v-card-actions>
          </v-toolbar>
          <v-layout column>
            <v-col cols="12" style="overflow: auto" class="p-0">
              <v-list-item-content class="pl-2 pr-2">
                <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected"
                  :headers="selected_headers"
                  :items="selected_table_data"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1"
                >
                  <template #[`item.action`]="{ item }">
                    <img
                      @click="deleteEvent(item)"
                      src="@/assets/images/delete_red.png"
                      title="Delete item"
                    />
                  </template>
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{
                      item.sub_location ? item.sub_location : "-"
                    }}</span>
                  </template>
                </v-data-table>
              </v-list-item-content>
            </v-col>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Create request popup -->
    <v-row justify="center">
      <v-dialog
        v-model="assignExecutivePopup"
        persistent
        max-width="367px"
        style="max-height: 100%;}"
      >
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Create Request</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="assignExecutivePopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row style="justify-content: center" class="margin-right">
                <v-autocomplete
                  v-model="requestReason"
                  variant="outlined"
                  :items="request_reason"
                  item-title="name"
                  item-value="id"
                  label="Request Reason"
                  style="max-width: 300px"
                ></v-autocomplete>
                <br />
                <v-autocomplete
                  v-model="assignTo"
                  variant="outlined"
                  :items="inward_users"
                  item-title="username"
                  item-value="id"
                  label="Assign To"
                  style="width: 300px"
                  multiple
                  chips
                  clearable
                ></v-autocomplete>
                <u
                  ><a href="#" class="select-all-link" @click="selectAll"
                    >Select All</a
                  ></u
                >
                <!-- <div v-if="assignData.length > 0">
                    <div class="selected_rule_box">
                      <span v-for="itemId in assignData" :key="itemId" class="rule-type_option">
                        {{ getItemName(itemId) }}
                        <v-icon size='small' @click="removeItem(itemId)">mdi-close</v-icon>
                      </span>
                    </div>
                  </div> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="margin-10">
            <!-- <v-spacer></v-spacer> -->
            <v-btn
              size='small'
              variant="text"
              class="btn-cancel  text-none mr-2 mb-3"
              @click="assignExecutivePopup = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              color="primary"
              variant="flat"
              class="mb-3  text-none"
              @click="assignExecutiveSubmit"
              :disabled="number > 0 || !assignTo || !requestReason"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update sublocation popup -->
    <v-row justify="center">
      <v-dialog v-model="updateSubLocationReq" persistent max-width="450px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Update Sub Location</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="updateSubLocationReq = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="d-flex justify-center align-self-center w-100">
                <v-autocomplete
                  v-model="sub_lcation_inward"
                  variant="outlined"
                  :items="update_sub_location"
                  item-title="code"
                  item-value="id"
                  label="Select Location"
                  style="max-width: 300px"
                ></v-autocomplete>
             
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              size='small'
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="updateSubLocationReq = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              color="primary"
              variant="flat"
              class="mb-3 text-none"
              :disabled="!sub_lcation_inward"
              @click="updateSubLocSubmit"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Selected items popup in open-putaway -->
    <v-row justify="center">
      <v-dialog
        v-model="selctedItemsOpenPopup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="v-card-100 m-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title
              >Selected
              {{ selected_table_data_open.length }} Items</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn
                class="text-blue bg-white text-none"
                size='small'
                @click="assignExecutiveFncInOpen"
                >Assign Executive</v-btn
              >
              <v-btn
                class="text-blue bg-white text-none"
                size='small'
                @click="addMoreItemsOpenTab"
                >Add More Items</v-btn
              >
              <v-btn
                class="text-red bg-white text-none"
                size='small'
                @click="deleteRequestOpen"
                >Delete Request</v-btn
              >
              <v-btn icon dark class="text-white bg-primary" variant="solo" @click="selctedItemsOpenPopup = false"
                ><v-icon color="white">mdi-close</v-icon></v-btn
              >
            </v-card-actions>
          </v-toolbar>
          <v-layout column>
            <v-col cols="12" style="overflow: auto" class="p-0">
              <v-list-item-content class="pl-2 pr-2">
                <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected"
                  :headers="selected_headers_open"
                  :items="selected_table_data_open"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 mt-n6"
                >
                  <template #[`item.action`]="{ item }">
                    <img
                      @click="deleteEvent(item)"
                      src="@/assets/images/delete_red.png"
                      title="Delete item"
                    />
                  </template>
                </v-data-table>
              </v-list-item-content>
            </v-col>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Create request popup in open-putaway tab -->
    <v-row justify="center">
      <v-dialog
        v-model="assignExecutivePopupInOPen"
        persistent
        max-width="450px"
      >
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Create Request</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="assignExecutivePopupInOPen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="m-auto">
                <v-autocomplete
                  v-model="requestReasonOpen"
                  variant="outlined"
                  :items="request_reason_open"
                  hide-details
                  item-title="name"
                  item-value="id"
                  label="Request Reason"
                  style="max-width: 300px"
                ></v-autocomplete>
                <br />
                <v-autocomplete
                  v-model="assignToOpen"
                  variant="outlined"
                  :items="inward_users_open"
                  item-title="username"
                  item-value="id"
                  label="Assign To"
                  style="max-width: 300px"
                  multiple
                  chips
                  clearable
                ></v-autocomplete>
                <u
                  ><a href="#" class="select-all-link" @click="selectAll"
                    >Select All</a
                  ></u
                >
          </v-card-text>
          <v-card-actions class="d-flex align-self-center">
            <!-- <v-spacer></v-spacer> -->
            <v-btn
              size='small'
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="assignExecutivePopupInOPen = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              :color="number > 0 || !assignToOpen || !requestReasonOpen ? '' : 'primary'"
              class="mb-3 text-none"
              variant="flat"
              @click="assignExecuOpenSubmit"
              :disabled="number > 0 || !assignToOpen || !requestReasonOpen"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update sublocation popup in open-putaway tab -->
    <v-row justify="center">
      <v-dialog
        v-model="updateSubLocationReqOpenTab"
        persistent
        max-width="450px"
      >
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Update Sub Location</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="updateSubLocationReqOpenTab = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="d-flex justify-center align-self-center w-100">
              <v-autocomplete
                  color="primary"
                  v-model="updateSubLocOpen"
                  variant="outlined"
                  :items="update_sub_location_open"
                  item-title="code"
                  item-value="id"
                  label="Select Location"
                  style="max-width: 300px"
                ></v-autocomplete>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              size='small'
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="updateSubLocationReqOpenTab = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              color="primary"
              variant="flat"
              class="mb-3 text-none"
              @click="updateSubLocSubmitOpen"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-putaway" v-model="filteWithSubPopup" persistent :max-width="filter_width">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-combobox  v-if="active_tab != 'Request Tracker'" prepend-inner-icon="mdi-magnify" clearable v-model="filterCategory" :items="category_filter" item-title="value"
              item-value="value" label="Category" :style="{width: filter_field_width}" multiple variant="outlined" class="ma-2"
              ></v-combobox>
            <v-combobox v-if="active_tab != 'Request Tracker'" :style="{width: filter_field_width}" prepend-inner-icon="mdi-magnify" clearable v-model="filterGrade" :items="grade_filter" item-title="value" item-value="value" label="Grade" multiple variant="outlined"class="ma-2"
              ></v-combobox>
            <v-combobox v-if="active_tab != 'Request Tracker'" 
              :style="{width: filter_field_width}" 
              prepend-inner-icon="mdi-magnify" 
              clearable 
              v-model="filterBrand" 
              :items="brand_filter" 
              item-title="value" 
              item-value="value" 
              label="Brand" 
              multiple 
              variant="outlined" 
              class="ma-2"
              ></v-combobox>
            <v-autocomplete  v-if="active_tab == 'Request Tracker'" :style="{width: filter_field_width}" prepend-inner-icon="mdi-magnify" clearable v-model="filterRequestType" :items="filter_request_type" item-title="name" item-value="value" label="Request Type"  variant="outlined" class="ma-2"
            ></v-autocomplete>
            <v-autocomplete v-if="active_tab == 'Request Tracker'" :style="{width: filter_field_width}" prepend-inner-icon="mdi-magnify" clearable v-model="filterStatus" :items="filter_status" item-title="name" item-value="value" label="status"  variant="outlined" class="ma-2"
            ></v-autocomplete>

            <v-autocomplete  
               v-if="active_tab == 'Pick Up' && $isRelianceClient()" 
               :style="{width: filter_field_width}" 
               prepend-inner-icon="mdi-magnify" 
               clearable 
               v-model="filter_subLocation" 
               :items="sub_location_items" 
               item-title="name" 
               item-value="sub_location_id" 
               label="Sub Location"  
               variant="outlined" 
               class="ma-2"></v-autocomplete>
            <v-autocomplete  
              v-if="active_tab == 'Pick Up' && $isRelianceClient()" 
              :style="{width: filter_field_width}" 
              prepend-inner-icon="mdi-magnify" 
              clearable 
              v-model="filter_distributionNumber" 
              :items="site_location_items" 
              item-title="name" 
              item-value="site_location_id" 
              label="Site Location"  
              variant="outlined" class="ma-2"
            ></v-autocomplete>
            <v-text-field :style="{width: filter_field_width}" prepend-inner-icon="mdi-magnify" v-if="active_tab == 'Pick Up' && $isRelianceClient()" v-model="filter_tagId" label="Serial Number" style="max-width: 300px;" variant="outlined" class="ma-2"></v-text-field>
            <v-text-field :style="{width: filter_field_width}" prepend-inner-icon="mdi-magnify" v-if="active_tab == 'Pick Up' && $isRelianceClient()" v-model="filter_skuCode" label="SKU Code" style="max-width: 300px;" variant="outlined" class="ma-2"></v-text-field>
            <!-- <v-text-field prepend-inner-icon="mdi-magnify" v-if="active_tab == 'Pick Up' && $isRelianceClient()" v-model="filter_itemDescription" label="Article Description" style="max-width: 300px;" outlined class="ma-2"></v-text-field> -->
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn small text class="btn-cancel mr-2 mb-3 text-none" @click="clearFilterData">Cancel</v-btn>
            <v-btn small color="primary" variant="flat" class="mb-3 text-none" @click="applyFilterFunc" :disabled="number > 0">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- <v-row justify="center">
      <v-dialog
        content-class="filter-putaway"
        v-model="filteWithSubPopup"
        persistent
        :max-width="filter_width"
      >
        <v-card> 
          <v-card-text class="d-flex align-center px-2">
            <v-row>
              <v-col v-if="active_tab != 'Request Tracker'">
                <v-combobox
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  color="primary"
                  v-model="filterCategory"
                  :items="category_filter"
                  item-title="value"
                  item-value="value"
                  label="Category"
                  multiple
                  :style="{width: filter_field_width}"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
              <v-col v-if="active_tab != 'Request Tracker'">
                <v-combobox
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  color="primary"
                  v-model="filterGrade"
                  :items="grade_filter"
                  item-title="value"
                  item-value="value"
                  label="Grade"
                  multiple
                  :style="{width: filter_field_width}"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
              <v-col v-if="active_tab != 'Request Tracker'">
                <v-combobox
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  color="primary"
                  v-model="filterBrand"
                  :items="brand_filter"
                  item-title="value"
                  item-value="value"
                  label="Brand"
                  multiple
                  :style="{width: filter_field_width}"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'Request Tracker'">
                <v-autocomplete
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  color="primary"
                  v-model="filterRequestType"
                  :items="filter_request_type"
                  item-title="name"
                  item-value="value"
                  label="Request Type"
                  :style="{width: filter_field_width}"
                  variant="outlined"
                  class="ma-2"
                ></v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Request Tracker'">
                <v-autocomplete
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  color="primary"
                  v-model="filterStatus"
                  :items="filter_status"
                  item-title="name"
                  :style="{width: filter_field_width}"
                  item-value="value"
                  label="status"
                  variant="outlined"
                  class="ma-2"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete  v-if="active_tab == 'Pick Up' && $isRelianceClient()" prepend-inner-icon="mdi-magnify" clearable :style="{width: filter_field_width}" v-model="filter_subLocation" :items="sub_location_items" item-title="name" item-value="sub_location_id" label="Sub Location"  variant="outlined" class="ma-2"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete  v-if="active_tab == 'Pick Up' && $isRelianceClient()" prepend-inner-icon="mdi-magnify" clearable :style="{width: filter_field_width}" v-model="filter_distributionNumber" :items="site_location_items" item-title="name" item-value="sub_location_id" label="Site Location"  variant="outlined" class="ma-2"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" v-if="active_tab == 'Pick Up' && $isRelianceClient()" :style="{width: filter_field_width}" v-model="filter_skuCode" label="SKU Code" style="max-width: 300px;" variant="outlined" class="ma-2"></v-text-field>
              </v-col>
              <v-text-field prepend-inner-icon="mdi-magnify" v-if="active_tab == 'Pick Up' && $isRelianceClient()" :style="{width: filter_field_width}" v-model="filter_tagId" label="Serial Number" style="max-width: 300px;" outlined class="ma-2"></v-text-field>
               <v-text-field prepend-inner-icon="mdi-magnify" v-if="active_tab == 'Pick Up' && $isRelianceClient()" v-model="filter_itemDescription" label="Article Description" style="max-width: 300px;" outlined class="ma-2"></v-text-field> -->
          
           <!-- </v-row>
          </v-card-text>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn
              size="small"
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="clearFilterData"
              >Cancel</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              color="primary"
              class="mb-3 text-none"
              @click="applyFilterFunc"
              :disabled="number > 0"
              >Apply Filter(s)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row> -->
    <!-- write off item selected items popup -->
    <!-- <v-row justify="center">
      <v-dialog v-model="selctedItemsPopInNF" persistent max-width="1000px">
        <v-card class="v-card-100">
          <v-toolbar dark color="primary">
          <v-toolbar-title>Selected {{selected.length}} Items</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn
                  class="mr-2 btn-color-text"
                 color="#FFFFFF"
                 @click="dialogWriteOffItem"
                >RAISE DEBIT NOTE</v-btn>
                <v-btn
                class="mr-2 btn-color-text"
                 color="#FFFFFF"
                 @click="addMoreItems"
                >ADD MORE ITEMS</v-btn>
                <v-btn
                  class="mr-2 btn-color-red"
                 color="#FFFFFF"
                 @click="deleteRequest"
                >DELETE All</v-btn>
            <v-btn icon dark @click="selctedItemsPopInNF = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-layout column>
          <v-col cols="12" style="overflow: auto" class="p-0">
              <v-data-table hover
                density="compact"
                :search="search"
                v-model="selected"
                :headers="selected_headers_NFI"
                :items="selected_table_data_NFI"
                :loading="loading"
                loading-text="Loading Data... Please wait"
                class="elevation-1"
              >
              <template v-slot:item.action="{ item }">
                <img @click="deleteEvent(index)" src="@/assets/images/delete_red.png"
                  title="Delete item" />
              </template>
              </v-data-table>
            </v-col>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row> -->

    <!-- Write off items popup  -->
    <v-row justify="center">
      <v-dialog v-model="writeOffItemsPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Write Off Items</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="writeOffItemsPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-form>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field
                      hide-details
                      color="primary"
                      label="Raise Note Against"
                      variant="outlined"
                      v-model="raise_note_against"
                      type="text"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field
                      color="primary"
                      label="Debit Amount"
                      variant="outlined"
                      v-model="debit_amount"
                      :min="0"
                      oninput="validity.valid||(value='');"
                      type="number"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              class="btn-cancel mr-2 mb-3  text-none"
              size='small'
              variant="text"
              @click="writeOffItemsPopup = false"
              >Cancel</v-btn
            >
            <!-- <v-btn outlined class="submit-color mb-3" @click="writeOffItemSubmit" :disabled=" number >0 || !raise_note_against || !debit_amount">submit</v-btn> -->
            <v-btn
              :color="number > 0 || !raise_note_against || !debit_amount ? '' : 'primary'"
              class="mb-3 text-none"
              size='small'
              variant="flat"
              @click="writeOffItemSubmit"
              :disabled="number > 0 || !raise_note_against || !debit_amount"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Upate sublocation popup in Not Found Item tab -->
    <v-row justify="center">
      <v-dialog v-model="updateSubLocationNFI" persistent max-width="450px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Update Sub Location</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="updateSubLocationNFI = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="d-flex justify-center align-self-center w-100">
            <v-autocomplete
                  v-model="updateSubLocNFI"
                  variant="outlined"
                  :items="update_sub_location_nfi"
                  item-title="code"
                  item-value="id"
                  color="primary"
                  label="Select Location"
                  style="max-width: 300px"
                ></v-autocomplete>
             </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              size='small'
              variant='text'
              class="btn-cancel mr-2 mb-3 text-none"
              @click="updateSubLocationNFI = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              color="primary"
              class="mb-3 text-none"
              variant="flat"
              @click="updateSubLocSubmitNfi"
              :disabled="!updateSubLocNFI"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- success popup in inward putaway -->
    <v-row justify="center">
      <v-dialog v-model="successDialogInward" persistent max-width="480px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon @click="successDialogInward = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-title style="margin-top: -13px">
            <span style="font-size: initial">{{ successMsg }}</span>
          </v-card-title>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              class="text-blue text-none"
              color="white"
              size='small'
              @click="successDialogInward = false"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Pick up selected popup -->
    <v-row justify="center">
      <v-dialog
        v-model="selctedItemsPickup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="v-card-100 m-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title
              >Selected
              {{ table_data_pickup_sel.length }} Items</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn
                class="text-blue bg-white text-none"
                size='small'
                @click="assignExecutivePickup"
                >Assign Executive</v-btn
              >
              <v-btn
                class="text-blue bg-white text-none"
                size='small'
                @click="addMoreItems"
                >Add More Items</v-btn
              >
              <v-btn
                class="text-red bg-white text-none"
                size='small'
                @click="deleteRequestPickup"
                >Delete Request</v-btn
              >
              <v-btn icon dark variant="solo" @click="selctedItemsPickup = false"
                ><v-icon color="white">mdi-close</v-icon></v-btn
              >
            </v-card-actions>
          </v-toolbar>
          <v-layout column>
                <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected"
                  :headers="headers_pickup_sel"
                  :items="table_data_pickup_sel"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1"
                >
                  <template #[`item.action`]="{ item }">
                    <img
                      @click="deleteEvent(item)"
                      src="@/assets/images/delete_red.png"
                      title="Delete item"
                    />
                  </template>
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{
                      item.sub_location ? item.sub_location : "-"
                    }}</span>
                  </template>
                </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Create request popup in Pick Up -->
    <v-row justify="center">
      <v-dialog
        v-model="assignExecutivePopupPickup"
        persistent
        max-width="450px"
      >
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Create Request</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="assignExecutivePopupPickup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="m-auto">
          
                <v-autocomplete
                  v-model="requestReasonPickup"
                  variant="outlined"
                  :items="reason"
                  item-title="name"
                  hide-details
                  item-value="id"
                  label="Request Reason"
                  style="max-width: 300px"
                ></v-autocomplete>
                <br />
                <v-autocomplete
                  v-model="assignToPickup"
                  variant="outlined"
                  :items="users_pickup"
                  item-title="username"
                  item-value="id"
                  label="Assign To"
                  style="max-width: 300px"
                  multiple
                  chips
                  clearable
                ></v-autocomplete>
                <u
                  ><a href="#" class="select-all-link" @click="selectAll"
                    >Select All</a
                  ></u
                >
          </v-card-text>
          <v-card-actions class="d-flex align-self-center" >
            <v-btn
              size='small'
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="assignExecutivePopupPickup = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              :color="number > 0 || !assignToPickup || !requestReasonPickup ? '' : 'primary'"
              class="mb-3 text-none"
              variant="flat"
              @click="assignExSubmitPickup"
              :disabled="number > 0 || !assignToPickup || !requestReasonPickup"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Cancel Request Pop up in Request Tracker -->
    <v-row justify="center">
      <v-dialog v-model="cancelRequestPopup" persistent max-width="470px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="cancelRequestPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-title style="margin-top: -13px">
            <span>Are you sure you want to cancel requests?</span>
          </v-card-title>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              class="btn-cancel mr-2 mb-3 text-none"
              size='small'
              variant="text"
              @click="cancelRequestPopup = false"
              >No</v-btn
            >
            <v-btn
              color="primary"
              class="mb-3 mr-5 text-none"
              size='small'
              variant="flat"
              @click="cancelRequestSubmit"
              >Yes</v-btn
            >
          </v-card-actions>
          <v-spacer></v-spacer>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- change assignment popup request tracker -->
    <v-row justify="center">
      <v-dialog v-model="changeAssignmentPopup" persistent max-width="450px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Change Assignee</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="changeAssignmentPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="m-auto" style="margin-left: 55px !important;">
                <v-autocomplete
                  v-model="change_assignment"
                  variant="outlined"
                  :items="change_assignment_items"
                  item-title="username"
                  item-value="id"
                  label="Choose the Executive"
                  style="max-width: 300px"
                  multiple
                  chips
                  clearable
                ></v-autocomplete>
                <u
                  ><a href="#" class="select-all-link" @click="selectAll"
                    >Select All</a
                  ></u
                >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              size='small'
              variant="text"
              class="btn-cancel mr-2 mb-3 text-none"
              @click="changeAssignmentPopup = false"
              >Cancel</v-btn
            >
            <v-btn
              size='small'
              :color="number > 0 || !change_assignment ? '' : 'primary'"
              class="mb-3 text-none"
              variant="flat"
              @click="changeAssignConfirm"
              :disabled="number > 0 || !change_assignment"
              >Confirm</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Edit request popup in request tracker -->
    <v-row justify="center">
      <v-dialog
        v-model="editRequestPopup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title class="alert-link"
            >Edit Request {{ req_id }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn
              class="text-blue bg-white text-none"
              size='small'
              @click="editrequestSave"
              :disabled="number > 0"
              >Save & Update</v-btn
            >
            <v-btn icon variant="solo" dark @click="editRequestPopup = false"
              ><v-icon color="white">mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-toolbar>
        <v-card class="v-card-100 m-0">
          <v-toolbar color="white" elevation="3">
            <v-spacer></v-spacer>
            <v-card-actions >
              <v-btn
                class="text-blue bg-white text-none"
                size='small'
                elevation="3"
                @click="addMoreItemsReqTrack"
                >Add More Items</v-btn
              >
              <v-btn
                class="text-blue bg-white text-none"
                size='small'
                elevation="3"
                @click="changeAssignmentEditFunc"
                >Change Assignment</v-btn
              >
              <v-btn
                class="text-red bg-white text-none"
                size='small'
                elevation="3"
                @click="deleteReqTracker"
                >Delete Request</v-btn
              >
            </v-card-actions>
          </v-toolbar>
          <v-card-text class="px-0 py-1">
                <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected"
                  :headers="edit_req_headers"
                  :items="edit_req_table_data"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1"
                >
                  <template #[`item.action`]="{ item }">
                    <img
                      @click="deleteEvenTrack(item)"
                      src="@/assets/images/delete_red.png"
                      title="Delete item"
                    />
                  </template>
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{
                      item.sub_location ? item.sub_location : "-"
                    }}</span>
                  </template>
                  <template v-slot:item.serial_number="{item}" v-if="$isRelianceClient()">
                    <span>{{ item.serial_number ? item.serial_number : "-"}}</span>
                  </template>
                </v-data-table>
              </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- change assignment pop in edit assignment -->
    <v-row justify="center">
      <v-dialog
        v-model="changeAssignmentEditPopup"
        persistent
        max-width="450px"
      >
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
              <span>Change Assignee</span><br />
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="changeAssignmentEditPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="m-auto">
                <v-autocomplete
                  v-model="change_assignment_item_edit"
                  variant="outlined"
                  :items="change_assignment_edit_items"
                  item-title="username"
                  item-value="id"
                  label="Choose the Executive"
                  style="max-width: 300px"
                  multiple
                  chips
                  clearable
                ></v-autocomplete>
                <u
                  ><a href="#" class="select-all-link" @click="selectAllForEdid"
                    >Select All</a
                  ></u
                >
          </v-card-text>
          <v-card-actions class="d-felx align-self-center">
            <!-- <v-spacer></v-spacer> -->
            <v-btn
              size='small'
              :color="number > 0 || !change_assignment_item_edit ? '' : 'primary'"
              class="mb-3 text-none"
              variant="flat"
              @click="changeAssignmentEditPopup = false"
              :disabled="number > 0 || !change_assignment_item_edit"
              >Ok</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="rejectsussesspopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="rejectsussesspopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>

          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" 
              variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- add more items popup in request tracker -->
    <v-row justify="center">
      <v-dialog
        v-model="addMoreItemsPopup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title class="alert-link"
            >Selected items {{ this.selected_add.length }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn
              class="text-blue bg-white text-none"
              size='small'
              @click="addButton"
              :disabled="this.selected_add.length == 0"
              >Add</v-btn
            >
            <v-btn icon dark variant="solo" @click="addMoreItemsPopup = false"
              ><v-icon color='white'>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-toolbar>
        <v-card class="v-card-100 m-0">
          <v-toolbar class="tool_search" color="white" 
            elevation="3">
            <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              v-model="add_item_search"
              label="Search"
              style="max-width: 300px; margin-top: 28px"
              variant="outlined"
              v-on:keyup.enter="addMoreItemsReqTrack()"
            ></v-text-field>
          </v-toolbar>
          <v-card-text class="px-0 py-1">
                <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected_add"
                  show-select
                  :headers="add_items_headers"
                  :items="add_items_table_data"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 addmoreitemstable"
                  return-object
                >
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{
                      item.sub_location ? item.sub_location : "-"
                    }}</span>
                  </template>
                </v-data-table>
              </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Item Link request popup in request tracker -->
    <v-row justify="center">
      <v-dialog
        v-model="itemLinkPopup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title class="alert-link">{{ req_id }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn
              class="text-blue bg-white text-none"
              size='small'
              @click="manfSubmit"
              v-if="reqTrackStatus !== 'Completed'"
              :disabled="number > 0 || !canMarkAsNotFound"
              >Mark As Not Found</v-btn
            >
            <v-btn icon dark @click="itemLinkPopup = false"
              ><v-icon color="white">mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-toolbar>
        <v-card class="v-card-100 m-0">
          <v-card-text>
                <v-data-table hover
                  density="compact"
                  show-select
                  :search="search"
                  v-model="selected_manf"
                  :headers="edit_req_headers"
                  :items="edit_req_table_data"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1"
                  return-object
                >
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{
                      item.sub_location ? item.sub_location : "-"
                    }}</span>
                  </template>
                  <template #[`item.status`]="{ item }">
                    <span>{{ item.status ? item.status : "-" }}</span>
                  </template>
                </v-data-table>
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card class="v-card-100">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab
          style="text-transform: none !important"
          @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs"
          :key="index"
           class="component-tab-heading tab-color"
          >{{ tab }}</v-tab
        >
      </v-tabs>
    </v-card>
    <v-card-title class="action-style">
      <v-row class="m-0">
        <v-row class="m-0 d-flex align-center">
        <v-autocomplete
          class="mr-4"
          v-if="active_tab == 'Inward Putaway'"
          :items="field_item"
          v-model="field_type"
          item-value="value"
          style="max-width: 152px; min-height:50px;"
          item-title="name"
          hide-details
          color="primary"
          label="Select Field"
          variant="outlined"
        ></v-autocomplete>
        <v-text-field
          color="primary"
          prepend-inner-icon="mdi-magnify"
          v-if="active_tab != 'Pick Up'"
          v-model="putaway_search"
          label="Search"
          v-no-edge-space
          hide-details
          style="max-width: 300px; min-height:50px;"
          variant="outlined"
          v-on:keyup.enter="loadData(active_tab)"
        ></v-text-field>
        <v-text-field
          color="primary"
          prepend-inner-icon="mdi-magnify"
          v-if="active_tab == 'Pick Up'"
          v-model="putaway_search"
          v-no-edge-space
          label="Search"
          hide-details
          style="max-width: 300px"
          variant="outlined"
          v-on:keyup.enter="changeDispositon()"
        ></v-text-field>
       </v-row>
        <v-row class="m-0 d-flex align-center">
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="this.selected.length == 0"
              v-if="active_tab == 'Inward Putaway'  && isActionAllowed(role)"
              @click="createRequestPopup"
              >Create Request</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="this.selected.length == 0"
              v-if="active_tab == 'Inward Putaway'  && isActionAllowed(role)"
              @click="openSubLocationDialog"
              >Update Sub Location</v-btn
            >
            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="isButtonDisabled"
              v-if="active_tab == 'Open Putaway'  && isActionAllowed(role)"
              @click="openDialogOpenCreateRequest"
              >Create Request</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="this.selected.length == 0"
              v-if="active_tab == 'Open Putaway'  && isActionAllowed(role)"
              @click="openSubLocationDialogInOpen"
              >Update Sub Location</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="!requestTracListSelected"
              v-if="active_tab == 'Request Tracker'  && isActionAllowed(role)"
              @click="editRequestDialog"
              >Edit Request</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="!requestTracListSelected"
              v-if="active_tab == 'Request Tracker'  && isActionAllowed(role)"
              @click="cancelRequestDialogOpen"
              >Cancel Request</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              v-if="active_tab == 'Request Tracker'  && isActionAllowed(role)"
              :disabled="!requestTracListSelected"
              @click="changeAssignmentFunc"
              >Change Assignment</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              v-if="active_tab == 'Not Found Items'  && isActionAllowed(role)"
              :disabled="this.selected.length == 0"
              @click="dialogSubLocNfi"
              >Update Sub Location</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              v-if="active_tab == 'Not Found Items'  && isActionAllowed(role)"
              :disabled="this.selected.length == 0"
              @click="dialogWriteOffItem"
              >Write Off Items</v-btn
            >
            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="isButtonDisabled"
              v-if="active_tab == 'Pick Up' && isActionAllowed(role)"
              @click="dialogSelectedItemPickup"
              >Create Request</v-btn
            >

            <v-btn
              class="ma-2 text-none"
              color="primary"
              variant="flat"
               size="x-large"
              :disabled="this.selected.length == 0"
              v-if="active_tab == 'Pick Up'  && isActionAllowed(role)"
              @click="openSubLocationDialogInOpen"
              >Update Sub Location</v-btn
            >
          </v-card-actions>

          <v-expansion-panels
            class="custom-control_outlined  m-0 pt-1"
            ref="filterPopupRef"
            readonly
            style="max-width: 300px; margin: 0px; height: 52px"
            v-if="ForPickup"
          >
            <v-expansion-panel variant="outlined" style="margin-top:-4px" @click="filterListOfButtons">
              <v-expansion-panel-title
                >Filter
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-autocomplete
            v-model="pickup_disposition"
            :items="pickup_filter"
            item-title="key"
            item-value="value"
            variant="outlined"
            hide-details
            color="primary"
            label="Disposition"
            v-if="active_tab == 'Pick Up'  && isActionAllowed(role)"
            class="ml-2 mt-0 text-left height-auto"
            style="max-width: 300px; margin: 0px"
            @update:modelValue="changeDispositon"
          ></v-autocomplete>
        </v-row>
      </v-row>
    </v-card-title>
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          v-if="active_tab == 'Inward Putaway'"
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%"
          :loading="loading"
          :items-per-page='pageSize'
          loading-text="Loading Data... Please wait"
          class="elevation-1 index-table"
          return-object
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'customcheck'">
                <input
                  v-if="item.vendor_return_order_id == null"
                  type="checkbox"
                  :value="item"
                  id="item.id"
                  @change="assignvalue($event, item)"
                  name="check"
                  style="width: 18px; height: 18px; margin-top: 2px"
                  class="checkbox"
                />              
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
          </template>
          <!-- <template #[`item.customcheck`]="{ item }">
            <input
              v-if="item.vendor_return_order_id == null"
              type="checkbox"
              :value="item"
              id="item.id"
              @change="assignvalue($event, item)"
              name="check"
              style="width: 18px; height: 18px; margin-top: 2px"
              class="checkbox"
            /> -->
            <!-- <v-checkbox v-if="item.vendor_return_order_id != '' " :value="item" @click = "($event)" hide-details /> -->
          <!-- </template> -->
          <!-- <template #[`item.sub_location`]="{ item }">
            <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
          </template>
          <template #[`item.rdd_number`]="{ item }">
            <span>{{ item.rdd_number ? item.rdd_number : "-" }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
        <!-- Open putaway -->
        <v-data-table hover
          density="compact"
          :search="search"
          show-select
          v-model="selected"
          v-if="active_tab == 'Open Putaway'"
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data_open"
          fixed-header
          height="100%"
          :items-per-page='pageSize'
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1 index-table"
          return-object
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'customcheck'">
                <input
                  v-if="item.vendor_return_order_id == null"
                  type="checkbox"
                  :value="item"
                  id="item.id"
                  @change="assignvalue($event, item)"
                  name="check"
                  style="width: 18px; height: 18px; margin-top: 2px"
                  class="checkbox"
                />              
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
          </template>
          <!-- <template #[`item.customcheck`]="{ item }">
            <input
              v-if="item.vendor_return_order_id == null"
              type="checkbox"
              :value="item"
              id="item.id"
              @change="assignvalue($event, item)"
              name="check"
              style="width: 18px; height: 18px; margin-top: 2px"
              class="checkbox"
            /> -->
            <!-- <v-checkbox v-if="item.vendor_return_order_id != '' " :value="item" @click = "($event)" hide-details /> -->
          <!-- </template> -->
          <!-- <template #[`item.sub_location`]="{ item }">
            <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
          </template>
          <template v-slot:item.category="{item}">
            <span>{{ item.category ? item.category : "-"}}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
        <!-- not found items -->
        <v-data-table hover
          density="compact"
          :search="search"
          show-select
          v-model="selected"
          v-if="active_tab == 'Not Found Items'"
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data_notfound"
          fixed-header
          height="100%"
          :items-per-page='pageSize'
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1 index-table"
          return-object
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'customcheck'">
                <input
                  v-if="item.vendor_return_order_id == null"
                  type="checkbox"
                  :value="item"
                  id="item.id"
                  @change="assignvalue($event, item)"
                  name="check"
                  style="width: 18px; height: 18px; margin-top: 2px"
                  class="checkbox"
                />             
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
          </template>
          <!-- <template #[`item.customcheck`]="{ item }">
            <input
              v-if="item.vendor_return_order_id == null"
              type="checkbox"
              :value="item"
              id="item.id"
              @change="assignvalue($event, item)"
              name="check"
              style="width: 18px; height: 18px; margin-top: 2px"
              class="checkbox"
            /> -->
            <!-- <v-checkbox v-if="item.vendor_return_order_id != '' " :value="item" @click = "($event)" hide-details /> -->
          <!-- </template>
          <template #[`item.sub_location`]="{ item }">
            <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
        <!-- Pick up -->
        <v-data-table hover
          density="compact"
          :search="search"
          show-select
          v-model="selected"
          v-if="active_tab == 'Pick Up'"
          :headers="headers_pickup"
          :items="table_data_pickup"
          :items-per-page='pageSize'
          fixed-header
          height="100%"
          :loading="loading"
          disable-pagination
          :hide-default-footer="true"
          loading-text="Loading Data... Please wait"
          class="elevation-1 index-table"
          return-object
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'customcheck'">
                <input
                  v-if="item.vendor_return_order_id == null"
                  type="checkbox"
                  :value="item"
                  id="item.id"
                  @change="assignvalue($event, item)"
                  name="check"
                  style="width: 18px; height: 18px; margin-top: 2px"
                  class="checkbox"
                />             
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
        </template>
          <!-- <template #[`item.customcheck`]="{ item }">
            <input
              v-if="item.vendor_return_order_id == null"
              type="checkbox"
              :value="item"
              id="item.id"
              @change="assignvalue($event, item)"
              name="check"
              style="width: 18px; height: 18px; margin-top: 2px"
              class="checkbox"
            /> -->
            <!-- <v-checkbox v-if="item.vendor_return_order_id != '' " :value="item" @click = "($event)" hide-details /> -->
          <!-- </template>
          <template #[`item.sub_location`]="{ item }">
            <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
          </template>
          <template v-slot:item.serial_number="{item}">
            <span>{{ item.serial_number ? item.serial_number : "-"}}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
        <!-- Request Tracker -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          v-if="active_tab == 'Request Tracker'"
          :headers="headers"
          :items="table_data_request_track"
          :items-per-page='pageSize'
          fixed-header
          height="100%"
          :loading="loading"
          disable-pagination
          :hide-default-footer="true"
          loading-text="Loading Data... Please wait"
          class="elevation-1 index-table"
          return-object
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'request_id'">
                <a @click="linkPopupInReqTracker(item)" style="color: #1976d2">
                  <u> {{ item.request_id }}</u>
                </a>             
              </span> 
              <span v-else-if="header.key == 'customcheck'">
                <input
                  v-if="item.vendor_return_order_id == null"
                  type="checkbox"
                  :value="item"
                  id="item.id"
                  @change="($event) => assignvalue($event, item)"
                  name="check"
                  style="width: 18px; height: 18px; margin-top: 2px"
                  class="checkbox"
                />             
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
        </template>
        
          <!-- <template #[`item.customcheck`]="{ item }">
            <input
              v-if="item.vendor_return_order_id == null"
              type="checkbox"
              :value="item"
              id="item.id"
              @change="($event) => assignvalue($event, item)"
              name="check"
              style="width: 18px; height: 18px; margin-top: 2px"
              class="checkbox"
            />
          </template> -->
          <!-- <template #[`item.completed_at`]="{ item }">
            <span>{{ item.completed_at ? item.completed_at : "-" }}</span>
          </template> -->
          <!-- <template #[`item.assignee_name`]="{ item }">
            <span style="text-wrap : balance ">{{ item.assignee_name ? item.assignee_name : "-" }}</span>
          </template> -->
          <!-- <template #[`item.request_id`]="{ item }">
            <a @click="linkPopupInReqTracker(item)" style="color: #1976d2">
              <u> {{ item.request_id }}</u>
            </a>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import { securedAxiosInstance } from "@/backend/axios";
import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
// import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';

export default {
  data() {
    return {
      headerText: "Putaway",
      rejectsussesspopup: false,
      number: 0,
      tabs: [
        "Inward Putaway",
        "Open Putaway",
        "Pick Up",
        "Request Tracker",
        "Not Found Items",
      ],
      selected_tab : 0,
      active_tab: "Inward Putaway",
      selected: [],
      selected_add: [],
      search: "",
      putaway_search: "",
      headers: [
        {
          title: "Tag ID",
          key: "tag_number",
          width: "12%",
          align: "start",
          sortable: false,
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
        { title: "RDD", key: "rdd_number" },
      ],
      add_items_headers: [
        {
          title: "Tag ID",
          key: "tag_number",
          width: "12%",
          align: "start",
          sortable: false,
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
      ],
      add_items_table_data: [],
      table_data: [],
      table_data_open: [],
      selected_headers: [
        {
          title: "Tag ID",
          key: "tag_number",
          width: "12%",
          align: "start",
          sortable: false,
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
      ],
      selected_table_data: [],
      table_data_notfound: [],
      selctedItemsPopup: false,
      loading: true,
      alert: false,
      alert_type: "success",
      alert_message: "success",
      putaway: [],
      selectedPutwayList: "",
      inwardSelected: false,
      openListSelected: false,
      NotfoundListSelected: false,
      assignExecutivePopup: false,
      selctedItemsPopInNF: false,
      pickupaction: false,
      requestReason: "",
      assignTo: [],
      filterButtonPopup: false,
      filterCategory: [],
      filterGrade: [],
      filter_field_width:'',
      filterBrand: [],
      site_location_items: [],
      sub_location_items: [],
      filter_tagId: '',
      filter_skuCode: '',
      filter_itemDescription: '',
      filter_subLocation: null,
      filter_distributionNumber: null,
      category_filter: "",
      grade_filter: [],
      brand_filter: [],
      updateSubLocationReq: false,
      selctedItemsOpenPopup: false,
      assignExecutivePopupInOPen: false,
      updateSubLocationReqOpenTab: false,
      filteWithSubPopup: false,
      selected_table_data_open: [],
      dc_id: "",
      inv_id: [],
      update_inv_id: [],
      request_reason: "",
      request_reason_name: "",
      inward_users: "",
      update_sub_location: [],
      sub_lcation_inward: null,
      request_reason_open: "",
      inward_users_open: "",
      assignToOpen: [],
      requestReasonOpen: "",
      update_sub_location_open: "",
      updateSubLocOpen: null,
      currentFilterCategory: "",
      writeOffItemsPopup: false,
      raise_note_against: "",
      debit_amount: "",
      updateSubLocationNFI: false,
      updateSubLocNFI: "",
      update_sub_location_nfi: "",
      successDialogInward: false,
      successMsg: "",
      pickup_disposition: "",
      pickup_filter: "",
      selctedItemsPickup: false,
      assignExecutivePopupPickup: false,
      users_pickup: "",
      request_reason_pickup: "",
      requestReasonPickup: null,
      assignToPickup: [],
      pickupReason: "",
      pickup_reason: "",
      request_Type: "",
      requestType: "",
      reason: "",
      requestTracListSelected: false,
      cancelRequestPopup: false,
      changeAssignmentPopup: false,
      change_assignment: [],
      change_assignment_items: "",
      editRequestPopup: false,
      req_id: "",
      request_sl_id: "",
      table_data_request_track: [],
      assign_user: "",
      addMoreItemsPopup: false,
      add_item_search: "",
      filterStatus: "",
      filterRequestType: "",
      isButtonNeeded: false,
      selected_headers_open: [
        { title: "Tag ID", key: "tag_number", width: "12%", align: "start", sortable: false},
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code",minWidth:"160px" },
        { title: "Article Description", key: "item_description", minWidth:"250px" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location", minWidth:"200px" },
        { title: "Site Location", key: "distribution_center", minWidth:"200px"}        
        
      ],
      selected_table_data_NFI: [],
      selected_headers_NFI: [
        { title: "Tag ID", key: "tag_number", width: "12%", align: "start", sortable: false,},
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code",minWidth:"160px" },
        { title: "Article Description", key: "item_description",minWidth:"250px" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location",minWidth:"200px" },
        { title: "Site Location", key: "distribution_center",minWidth:"200px" },
      ],
      headers_pickup: [
        { title: "Tag ID", key: "tag_number", width: "12%", align: "start", sortable: false},
        { title: "Serial Number", key: "serial_number",minWidth:"200px" },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code",minWidth:"160px" },
        { title: "Article Description", key: "item_description",minWidth:"250px" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location",minWidth:"200px" },
        { title: "Disposition", key: "disposition" },
      ],
      table_data_pickup: [],
      edit_req_headers: [
        { title: "Tag ID", key: "tag_number", width: "12%", align: "start", sortable: false },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description",minWidth:"250px" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location",minWidth:"200px" },
        { title: "Site Location", key: "distribution_center",minWidth:"200px" },
      ],
      filter_request_type: [],
      requestTypes: [
        { value: "put_away", name: "Put Away" },
        { value: "pick_up", name: "Pick Up" },
      ],
      filter_status: [],
      trackStatus: [
        { value: "pending", name: "Pending" },
        { value: "in_progress", name: "In Progress",minWidth:"200px" },
        { value: "completed", name: "Completed" },
      ],
      edit_req_table_data: [],
      table_data_pickup_sel: [],
      headers_pickup_sel: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      field_item: [
        { name: "Tag Number", value: "tag_number" },
        { name: "IRD Number", value: "rdd_number" },
      ],
      field_type: null,
      itemLinkPopup: false,
      selected_manf: [],
      assignData: [],
      reqTrackStatus: "",
      change_assignment_edit_items: [],
      changeAssignmentEditPopup: false,
      change_assignment_item_edit: [],
      organization_name:'',
      ForPickup: false,
      applied_filter: true,
      filter_width:'',
      dispos_change:false,
    };
  },
  created() {
    this.organization_name = this.$store.state.organization_name;
    this.role = this.$store.state.currentUser.roles[0]
    if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Put Away/Pick Up')){
      signout()
      return;
    }
    const tab =  this.$store.state.active_tab
    if(tab == 'Not Found Items'){
      this.loadData('Not Found Items')
      this.selected_tab = 4
    } else if(tab == 'Request Tracker'){
      this.loadData('Request Tracker')
      this.selected_tab = 3
    } else if(tab == 'Pick Up'){
      this.loadData('Pick Up')
      this.selected_tab = 2
    } else if(tab == 'Open Putaway'){
      this.loadData('Open Putaway')
      this.selected_tab = 1
    } else {
      this.loadData('Inward Putaway')
      this.selected_tab = 0
    }
    this.pickupFilterOption();
    this.getFilterOption();
    this.getFilterSubLocation();
  },
  components: {
    HeaderComponent,
  },
  computed: {
    canMarkAsNotFound() {
      if (this.selected_manf.length === 0) {
        return false;
      }

      for (const item of this.selected_manf) {
        if (
          item.status !== "Pending pickup" &&
          item.status !== "Pending putaway"
        ) {
          return false;
        }
      }

      return true;
    },
    isButtonDisabled() {
      return (
        this.selected.length === 0 ||
        this.selected.some((item) => item.sub_location === null)
      );
    },
  },
  methods: {
    isActionAllowed(){
      return !isOnlyViewAction(this.role, 'Put Away/Pick Up')
    },
    pickupFilterOption(){
      if(this.$isRelianceClient()){
        this.ForPickup = true
      }else if(!this.$isRelianceClient() && this.active_tab === 'Pick Up'){
        this.ForPickup = false
      }else {
        this.ForPickup = true
      }
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    isDisabled() {
      return !this.isButtonNeeded;
    },
    getFilterOption() {
      securedAxiosInstance
        .get("/api/v1/warehouse/put_away/filters_data")
        .then((response) => {
          if (response.status === 200) {
            this.category_filter = response.data.categories;
            this.brand_filter = response.data.brands;
            this.grade_filter = response.data.grades;
          }
        });
    },
    getFilterSubLocation(){
      securedAxiosInstance
      .get("/api/v1/warehouse/put_away/get_site_location_for_filter?disposition=All")
      .then((response) => {
        if(response.status === 200){
          this.site_location_items = response.data.site_locations.map(item => ({
            name: item.site_location_code,
            site_location_id: item.site_location_id
          }));
          this.sub_location_items = response.data.sub_locations.map(item => ({
            name: item.sub_location_code,
            sub_location_id: item.sub_location_id
          }));
        }
      })
      .catch((error) => this.$toast.error("Error in retrieving data"))
    },
    loadData(tab, tab_action) {
      this.applied_filter = false;
      if (tab_action) {
        this.putaway_search = "";
        this.field_type = null;
        this.sub_location_sequence_search = "";
        this.sub_location_rules_search = "";
        this.dispos_change = false;
        this.selected = [];
      }

      if (this.active_tab != tab) {
        this.active_tab = tab;
        this.putaway_search = "";
        this.page = 1;
      }

      const params = this.getRequestParams(this.page, this.pageSize);
      this.$store.commit('setActiveTab',{
        'active_tab' : tab
      })
      if (tab == "Inward Putaway") {
        this.pickupFilterOption();
        this.pickup_disposition = "";
        this.table_data_open = [];
        this.table_data_pickup = [];
        this.loading = true;
        this.headers = [
          { title: "Tag ID", key: "tag_number",align: "start", sortable: false, minWidth:"120px" },
          { title: "Category", key: "category", sortable: true },
          { title: "Article Id", key: "sku_code", sortable: true, minWidth:"160px" },
          { title: "Article Description", key: "item_description",sortable: true, minWidth:"250px"},
          { title: "Grade", key: "grade", sortable: true },
          { title: "Sub Location", key: "sub_location", sortable: true, minWidth:"250px" },
          { title: "Site Location", key: "distribution_center",sortable: true, minWidth:"200px" },
          { title: "Inwarded Date", key: "inward_date", sortable: true, minWidth:"200px",
            sort: (a, b) => {
              const dateA = new Date(a.split("/").reverse().join("/"));
              const dateB = new Date(b.split("/").reverse().join("/"));
              return dateA - dateB;
            },
          },
          { title: "Disposition", key: "disposition",sortable: true},
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ];
        securedAxiosInstance
          .get("api/v1/warehouse/put_away", {
            params: {
              search: this.putaway_search,
              search_in: this.field_type,
              page: params["page"],
              per_page: params["size"],
            },
          })
          .then((response) => {
            this.table_data = response.data.inventories;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          })
          .catch((error) => this.$toast.error("Error in retrieving data"));
      }
      if (tab == "Open Putaway") {
        this.pickupFilterOption();
        this.pickup_disposition = "";
        this.table_data = [];
        this.table_data_pickup = [];
        this.loading = true;
        this.headers = [
          { title: "Tag ID", key: "tag_number", align: "start", sortable: false, minWidth:"120px"},
          { title: "Category", key: "category" },
          { title: "Article Id", key: "sku_code", minWidth:"160px" },
          { title: "Article Description", key: "item_description", minWidth:"250px" },
          { title: "Grade", key: "grade" },
          { title: "Sub Location", key: "sub_location", minWidth:"200px" },
          { title: "Site Location", key: "distribution_center", minWidth:"200px" },
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ];

        securedAxiosInstance
          .get("api/v1/warehouse/put_away?sub_location_status=open", {
            params: {
              tag_number: this.putaway_search,
              page: params["page"],
              per_page: params["size"],
            },
          })
          .then((response) => {
            this.table_data_open = response.data.inventories;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          })
          .catch((error) => this.$toast.error("Error in retrieving data"));
      }
      if (tab == "Not Found Items") {
        this.pickupFilterOption();
        this.pickup_disposition = "";
        this.table_data = [];
        this.table_data_pickup = [];
        this.loading = true;
        this.headers = [
          { title: "Tag ID", key: "tag_number", align: "start", sortable: false, minWidth:"120px"},
          { title: "Serial Number", key: "serial_number", minWidth:"200px" },
          { title: "Category", key: "category" },
          { title: "Article Id", key: "sku_code", minWidth:"160px" },
          { title: "Article Description", key: "item_description",  minWidth:"250px" },
          { title: "Grade", key: "grade" },
          { title: "Last Sub-Location", key: "sub_location", minWidth:"250px" },
          { title: "Site Location", key: "distribution_center", minWidth:"250px"  },
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"}
        ];
        securedAxiosInstance
          .get("api/v1/warehouse/put_away/not_found", {
            params: {
              tag_number: this.putaway_search,
              page: params["page"],
              per_page: params["size"],
            },
          })
          .then((response) => {
            this.table_data_notfound = response.data.inventories;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          })
          .catch((error) => this.$toast.error("Error in retrieving data"));
      }
      if (tab == "Pick Up") {
        this.pickupFilterOption();
        if(this.dispos_change === false){
          this.pickup_disposition = 'All';
        }
        this.changeDispositon();
        securedAxiosInstance
          .get("api/v1/warehouse/put_away/get_dispositions")
          .then((response) => {
            this.pickup_filter = response.data.dispositions;
          })
          .catch((error) => this.$toast.error("Error in retrieving data"));
      }
      if (tab == "Request Tracker") {
        this.pickupFilterOption();
        this.table_data = [];
        this.loading = true;
        this.headers = [
          { title: "", key: "customcheck", width: "3%" },
          { title: "Request ID", key: "request_id", align: "start", sortable: false, minWidth:"120"},
          { title: "Creation Date & Time", key: "created_at", minWidth:"300" },
          { title: "Request Type", key: "request_type", minWidth:"250" },
          { title: "Assigned To", key: "assignee_name", minWidth:"250" },
          { title: "Status", key: "status" },
          { title: "Completion Date & Time", key: "completed_at", minWidth:"300" },
          { title: "Not Found Items", key: "not_found_items", minWidth:"300" },
          { title: "Quantity", key: "items_count" },
        ];
        securedAxiosInstance
          .get("api/v1/warehouse/put_requests", {
            params: {
              request_id: this.putaway_search,
              page: params["page"],
              per_page: params["size"],
            },
          })
          .then((response) => {
            this.table_data_request_track = response.data.put_requests;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.filter_request_type = this.requestTypes;
            this.filter_status = this.trackStatus;
            this.loading = false;
          })
          .catch((error) => this.$toast.error("Error in retrieving data"));
      }
    },

    assignvalue(event, item) {
      console.log(event, "<====event, item ====>", item)
      if (event.target.checked) {
        if (this.selected.length == 0 || this.first_select == "") {
          this.first_select = item.issue_type;
          if (this.active_tab == "Pick Up" && !item.sub_location) {
            event.target.checked = false;
            this.showAlert(
              "error",
              "Please select a record that contains sub-location",
            );
          } else {
            this.selected.push(item);
            console.log(this.selected , "::: this.selected" , item)
          }
          if (item.issue_type == "In-Transit") {
            this.isReturn = true;
          }
          if (item.issue_type == "Excess") {
            this.isTranfer = true;
            this.isDisposition = true;
          }
        }
        if (this.first_select != "") {
          if (this.first_select == item.issue_type) {
            if (this.active_tab == "Pick Up" && !item.sub_location) {
              event.target.checked = false;
              this.showAlert(
                "error",
                "Please select a record that contains sub-location",
              );
            } else {
              if(this.selected.filter(selectedItem => selectedItem.id !== item.id).length){
                this.selected.push(item);
              }
            }
          } else {
            event.target.checked = false;
            this.$toast.error("Only one issue type can be selected at once");
          }
        }
      } else {
        var record = this.selected.find((x) => x.id == item.id);
        var ind = this.selected.indexOf(record);
        this.selected.splice(ind, 1);
        console.log(this.selected , ":::: this.selected");
      }

      if (this.active_tab == "Inward Putaway") {
        if (this.selected.length > 0) {
          this.inwardSelected = true;
        } else {
          this.inwardSelected = false;
        }
      }
      if (this.active_tab == "Open Putaway") {
        if (this.selected.length > 0) {
          this.openListSelected = true;
        } else {
          this.openListSelected = false;
        }
      }
      if (this.active_tab == "Not Found Items") {
        if (this.selected.length > 0) {
          this.NotfoundListSelected = true;
        } else {
          this.NotfoundListSelected = false;
        }
      }
      if (this.active_tab == "Pick Up") {
        if (this.selected.length > 0) {
          this.pickupaction = true;
        } else {
          this.pickupaction = false;
        }
      }

      if (this.active_tab == "Request Tracker") {
        if (this.selected.length > 0) {
          var dc = this.selected.map((x) => x.status);
          this.reqTrackStatus = dc;
          if (dc.includes("Pending") && dc.includes("Completed")) {
            this.requestTracListSelected = false;
          } else if (dc.includes("Pending") && dc.includes("In Progress")) {
            this.requestTracListSelected = false;
          } else if (dc.includes("Pending")) {
            this.requestTracListSelected = true;
          } else {
            this.requestTracListSelected = false;
          }
        } else {
          this.requestTracListSelected = false;
        }
      }
    },
    createRequestPopup() {
      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.inwardSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.selctedItemsPopup = true;
      this.selected_headers = [
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
        { title: "Delete", key: "action" },
      ];
      this.selected_table_data = this.selected;
      this.inv_id = this.selected.map((inventory) => inventory.id);
      var dato = unique_array[0];
      this.dc_id = dato.toString();
    },
    deleteEvent(item) {
      if (this.active_tab == "Inward Putaway") {
        const index = this.selected_table_data.indexOf(item);
        this.selected_table_data.splice(index, 1);
        this.inv_id = this.selected_table_data.map((x) => x.id);
        if (this.selected_table_data.length == 0) {
          this.selected_table_data = [];
          this.selctedItemsPopup = false;
          this.loadData(this.active_tab);
          var input = document.querySelectorAll(".checkbox");
          for (var i = 0; i < input.length; i++) {
            input[i].checked = false;
            this.inwardSelected = false;
          }
        }
      } else if (this.active_tab == "Open Putaway") {
        const index = this.selected_table_data_open.indexOf(item);
        this.selected_table_data_open.splice(index, 1);
        this.inv_id = this.selected_table_data_open.map((x) => x.id);
        if (this.selected_table_data_open.length == 0) {
          this.selected_table_data_open = [];
          this.selctedItemsOpenPopup = false;
          this.loadData(this.active_tab);
          let input = document.querySelectorAll(".checkbox");
          for (let i = 0; i < input.length; i++) {
            input[i].checked = false;
            this.openListSelected = false;
          }
        }
      } else if (this.active_tab == "Pick Up") {
        const index = this.table_data_pickup_sel.indexOf(item);
        this.table_data_pickup_sel.splice(index, 1);
        this.inv_id = this.table_data_pickup_sel.map((x) => x.id);
        if (this.table_data_pickup_sel.length == 0) {
          this.table_data_pickup_sel = [];
          this.selctedItemsPickup = false;
          this.loadData(this.active_tab);
          let input = document.querySelectorAll(".checkbox");
          for (let i = 0; i < input.length; i++) {
            input[i].checked = false;
            this.pickupaction = false;
          }
        }
      }
    },
    deleteEvenTrack(item) {
      const index = this.edit_req_table_data.indexOf(item);
      if (index > -1) {
        this.edit_req_table_data.splice(index, 1);
      }

      this.update_inv_id = this.edit_req_table_data.map((x) => x.inventory_id);

      if (this.edit_req_table_data.length === 0) {
        this.edit_req_table_data = [];
        this.editRequestPopup = false;
        this.loadData(this.active_tab);

        // Clear checkboxes
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
        }

        this.requestTracListSelected = false;
      }
    },
    assignExecutiveFnc() {
      this.number = 0;
      this.assignExecutivePopup = true;
      this.assignTo = null;
      this.requestReason = this.active_tab;
      this.$httpSecured
        .get("api/v1/warehouse/put_away/request_reasons", {
          params: { distribution_center_id: this.dc_id },
        })
        .then((response) => {
          if (response.data) {
            var request_reason_1 = response.data.put_away_reasons;
            request_reason_1.map((inward_reason) => {
              if (inward_reason.id == "inward_putaway") {
                this.request_reason = inward_reason.name;
              }
            });
            this.request_reason_name = response.data.put_away_reasons.map(
              (inventory) => inventory.name,
            );
            this.inward_users = response.data.users;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    assignExecutiveSubmit() {
      this.number++;
      // const formData = new FormData();

      this.$httpSecured
        .post("api/v1/warehouse/put_requests", {
          put_request: {
            request_type: "put_away",
            put_away_reason: "inward_putaway",
            distribution_center_id: this.dc_id,
            assignee_ids: this.assignTo,
            inventory_ids: this.inv_id,
          },
        })
        .then((response) => {
          if (response.data) {
            this.selctedItemsPopup = false;
            this.assignExecutivePopup = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.inwardSelected = false;
            }
            this.successDialogInward = true;
            this.successMsg = response.data.message;
            this.loadData(this.active_tab);
            this.showAlert("success", "Successfully request created");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },

    addMoreItems() {
      this.selctedItemsPopup = false;
      this.selctedItemsPickup = false;
    },

    filterListOfButtons(ev) {
        (this.filterCategory = []),
        (this.filterGrade = []),
        (this.filterBrand = []),
        (this.filter_subLocation = null),
        (this.filter_distributionNumber = null),
        (this.filterStatus = null),
        (this.filterRequestType = null),
        (this.putaway_search = "");
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 20
        ).toString() + "px",
      );
      this.filteWithSubPopup = true;
      this.filter_width = "1000px"
      this.filter_field_width = "170px";
      if(window.innerWidth > 1400 && window.innerWidth < 1500){
        this.filter_width = "1050px";
        this.filter_field_width = "170px";
      }else if(window.innerWidth >= 1500 && window.innerWidth < 1600){
        filter_width = "1150px";
        this.filter_field_width = "180px";
      }else if(window.innerWidth >= 1600){
        this.filter_width = "1250px"
      }
    },

    openSubLocationDialog() {
      if (this.selected.length <= 0) {
        this.showAlert("warning", "Please Select Item First");
        return;
      }
      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.inwardSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.updateSubLocationReq = true;
      this.sub_lcation_inward = null;
      var dato = unique_array[0];
      this.dc_id = dato.toString();

      this.inv_id = this.selected.map((inventory) => inventory.id);
      this.$httpSecured
        .get("api/v1/warehouse/put_away/sub_locations", {
          params: { distribution_center_id: this.dc_id },
        })
        .then((response) => {
          if (response.data) {
            this.update_sub_location = response.data.sub_locations;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    updateSubLocSubmit() {
      // const formData = new FormData();
      this.$httpSecured
        .put("api/v1/warehouse/put_away/update_sub_location", {
          inventory_ids: this.inv_id,
          sub_location_id: this.sub_lcation_inward,
          putaway_type: "inward",
        })
        .then((response) => {
          if (response.data) {
            this.updateSubLocationReq = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.inwardSelected = false;
            }
            this.showAlert("success", "Successfully updated");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    openDialogOpenCreateRequest() {
      if (this.selected.length <= 0) {
        this.showAlert("warning", "Please Select Item First");
        return;
      }
      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.openListSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.selctedItemsOpenPopup = true;
      this.selected_headers_open = [
        { title: "", key: "customcheck", width: "3%" },
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
        { title: "Delete", key: "action" },
      ];
      this.selected_table_data_open = this.selected;
      this.inv_id = this.selected.map((inventory) => inventory.id);
      var dato = unique_array[0];
      this.dc_id = dato.toString();
    },
    addMoreItemsOpenTab() {
      this.selctedItemsOpenPopup = false;
    },
    assignExecutiveFncInOpen() {
      this.number = 0;
      this.assignExecutivePopupInOPen = true;
      (this.assignToOpen = []), (this.requestReasonOpen = this.active_tab);
      this.$httpSecured
        .get("api/v1/warehouse/put_away/request_reasons", {
          params: { distribution_center_id: this.dc_id, status:'put_away'  },
        })
        .then((response) => {
          if (response.data) {
            var request_reason_open_1 = response.data.put_away_reasons;
            request_reason_open_1.map((open_reason) => {
              if (open_reason.id == "open_putaway") {
                console.log(open_reason , ":::: open_reason")
                this.request_reason_open = [open_reason];
              }
            });
            this.inward_users_open = response.data.users;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    assignExecuOpenSubmit() {
      this.number++;
      // const formData = new FormData();
      this.$httpSecured
        .post("api/v1/warehouse/put_requests", {
          put_request: {
            request_type: "put_away",
            put_away_reason: "open_putaway",
            distribution_center_id: this.dc_id,
            assignee_ids: this.assignToOpen,
            inventory_ids: this.inv_id,
          },
        })
        .then((response) => {
          if (response.data) {
            this.assignExecutivePopupInOPen = false;
            this.selctedItemsOpenPopup = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.openListSelected = false;
            }
            this.successDialogInward = true;
            this.successMsg = response.data.message;
            this.showAlert("success", "Successfully request created");
            this.loadData(this.active_tab);
            this.active_tab == "Decision Pending";
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },

    openSubLocationDialogInOpen() {
      if (this.selected.length <= 0) {
        this.showAlert("warning", "Please Select Item First");
        return;
      }

      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.openListSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.updateSubLocationReqOpenTab = true;
      this.updateSubLocOpen = null;
      var dato = unique_array[0];
      this.dc_id = dato.toString();
      this.inv_id = this.selected.map((inventory) => inventory.id);
      this.$httpSecured
        .get("api/v1/warehouse/put_away/sub_locations", {
          params: { distribution_center_id: this.dc_id },
        })
        .then((response) => {
          if (response.data) {
            this.update_sub_location_open = response.data.sub_locations;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    updateSubLocSubmitOpen() {
      // const formData = new FormData();
      this.$httpSecured
        .put("api/v1/warehouse/put_away/update_sub_location", {
          inventory_ids: this.inv_id,
          sub_location_id: this.updateSubLocOpen,
          putaway_type: "open",
        })
        .then((response) => {
          if (response.data) {
            this.updateSubLocationReqOpenTab = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.inwardSelected = false;
            }
            this.showAlert("success", "Successfully updated");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    deleteRequest() {
      if (this.selected.length > 0) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.inwardSelected = false;
        }
      }
      this.selctedItemsPopup = false;
    },
    deleteRequestOpen() {
      if (this.selected.length > 0) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.openListSelected = false;
        }
      }
      this.selctedItemsOpenPopup = false;
    },
    deleteRequestPickup() {
      if (this.selected.length > 0) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.pickupaction = false;
        }
      }
      this.selctedItemsPickup = false;
    },

    applyFilterFunc() {
      this.applied_filter = true;
      const accessoryTypes = ['Mobile Covers/Cases', 'Power bank/Batteries'];
      // this.pickup_disposition = 'Brand Call-Log'
      const params = new URLSearchParams();

      const categories = JSON.stringify(this.filterCategory.map(item => item.value));
      const brands = JSON.stringify(this.filterBrand.map(item => item.value));
      const grades = JSON.stringify(this.filterGrade.map(item => item.value));

      params.append('categories', categories !== '[]' ? categories : '');
      params.append('brands', brands !== '[]' ? brands : ''); 
      params.append('grade', grades !== '[]' ? grades : '');
      
      if(this.active_tab == 'Pick Up'){
        params.append('disposition', this.pickup_disposition);
        params.append('sub_location_id', this.filter_subLocation ? this.filter_subLocation : "");
        params.append('site_location_id', this.filter_distributionNumber ? this.filter_distributionNumber : "");
        params.append('serial_number', this.filter_tagId)
        params.append('article_id', this.filter_skuCode)
        // params.append('item_description', this.filter_itemDescription)
      }
      const pageparams = this.getRequestParams(
        this.page,
        this.pageSize
      );
      params.append('page' , pageparams['page'])
      params.append('per_page' , pageparams['size'])

      if(this.active_tab == 'Inward Putaway'){
        this.$httpSecured
        .get('/api/v1/warehouse/put_away', { params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.inventories
            this.totalPages =  response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filteWithSubPopup=false;
            
            this.loading = false;

          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }else if(this.active_tab == 'Open Putaway'){
        this.$httpSecured
        .get('api/v1/warehouse/put_away?sub_location_status=open', { params })
        .then(response => {
          if (response.data) {
            this.table_data_open = response.data.inventories
            this.filteWithSubPopup=false;
            this.totalPages =  response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.loading = false;

          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }else if(this.active_tab == 'Pick Up'){
        this.$httpSecured
        .get('/api/v1/warehouse/put_away/all_inventories', { params })
        .then(response => {
          if (response.data) {
            this.table_data_pickup = response.data.inventories
            this.filteWithSubPopup=false;
            this.totalPages =  response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.loading = false;

          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }else if(this.active_tab == 'Not Found Items'){
        this.$httpSecured
        .get('/api/v1/warehouse/put_away/not_found', { params })
        .then(response => {
          if (response.data) {
            this.table_data_notfound = response.data.inventories
            this.totalPages =  response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filteWithSubPopup=false;
            this.loading = false;

          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }else if(this.active_tab == 'Request Tracker'){
        // params.append('reuqest_type', this.filterRequestType);
        // params.append('status', this.filterStatus);
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        this.$httpSecured
          .get('api/v1/warehouse/put_requests', { params: { request_type: this.filterRequestType, status:this.filterStatus, page: params['page'], per_page: params['size'] } })
          .then(response => {
            if (response.data) {
              this.table_data_request_track = response.data.put_requests
              this.totalPages =  response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup=false;
              this.filterRequestType = '';
              this.filterStatus ='';
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      }
    },
    clearFilterData(){
      this.filteWithSubPopup=false;
      if(this.active_tab == 'Inward Putaway'){
        this.filterCategory = '';
        this.filterGrade = '';
        this.filterBrand = '';
        this.filter_subLocation = '';
        this.filter_distributionNumber = '';
      }else if(this.active_tab == 'Open Putaway'){
        this.filterCategory = '';
        this.filterGrade = '';
        this.filterBrand = '';
      }else if(this.active_tab == 'Pick Up'){           
        this.filterCategory = '';
        this.filterGrade = '';
        this.filterBrand = '';
        this.filter_tagId = '';
        this.filter_skuCode = '';
        this.filter_itemDescription = '';
        this.filter_subLocation = '';
        this.filter_distributionNumber = '';
      }else if(this.active_tab == 'Not Found Items'){           
        this.filterCategory = '';
        this.filterGrade = '';
        this.filterBrand = '';
      }else{            
        this.filterRequestType = '';
        this.filterStatus ='';
      }
    },
    selectedItemDailogNF() {
      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.NotfoundListSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.selctedItemsPopInNF = true;
      this.selected_headers_NFI = [
        { title: "", key: "customcheck", width: "3%" },
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
        { title: "Delete", key: "action" },
      ];
      this.selected_table_data_NFI = this.selected;
      this.inv_id = this.selected.map((inventory) => inventory.id);
      var dato = unique_array[0];
      this.dc_id = dato.toString();
    },
    dialogWriteOffItem() {
      this.number = 0;
      if (this.selected.length == 1) {
        this.writeOffItemsPopup = true;
        this.debit_amount = "";
        this.raise_note_against = "";
      } else {
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.selected = [];
          this.NotfoundListSelected = false;
        }
        this.showAlert("error", "Select only One items");
      }
    },
    writeOffItemSubmit() {
      this.number++;
      var dc = this.selected.map((x) => x.id);
      const formData = new FormData();
      formData.append("raised_against", this.raise_note_against);
      formData.append("debit_amount", this.debit_amount);
      this.$httpSecured
        .put("/api/v1/warehouse/put_away/" + dc + "/write_off", formData)
        .then((response) => {
          if (response.data) {
            this.update_sub_location_open = response.data.sub_locations;
            this.loading = false;
            this.writeOffItemsPopup = false;
            this.showAlert("success", "Successfully updated");
            this.selected = [];
            this.loadData(this.active_tab);
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.message);
          this.loading = false;
        });
    },

    dialogSubLocNfi() {
      if (this.selected.length <= 0) {
        this.showAlert("warning", "Please Select Item First");
        return;
      }

      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.openListSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.updateSubLocationNFI = true;
      this.updateSubLocNFI = "";
      var dato = unique_array[0];
      this.dc_id = dato.toString();
      this.inv_id = this.selected.map((inventory) => inventory.id);
      this.$httpSecured
        .get("api/v1/warehouse/put_away/sub_locations", {
          params: { distribution_center_id: this.dc_id },
        })
        .then((response) => {
          if (response.data) {
            this.update_sub_location_nfi = response.data.sub_locations;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    updateSubLocSubmitNfi() {
      // const formData = new FormData();
      this.$httpSecured
        .put("api/v1/warehouse/put_away/update_sub_location", {
          inventory_ids: this.inv_id,
          sub_location_id: this.updateSubLocNFI,
          putaway_type: "not_found",
        })
        .then((response) => {
          if (response.data) {
            this.updateSubLocationNFI = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.NotfoundListSelected = false;
            }
            this.showAlert("success", "Successfully updated");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    changeDispositon() {
      const params = this.getRequestParams(this.page, this.pageSize);

      this.loading = true
      this.headers_pickup = [
        { title: "Tag ID", key: "tag_number",align: "start", sortable: false, width: "12%"},
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code",minWidth:"160px" },
        { title: "Article Description", key: "item_description",minWidth:"250px" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location",minWidth:"200px" },
        { title: "Site Location", key: "distribution_center",minWidth:"200px" },
        { title: "Disposition", key: "disposition" },
        { title: "IRRD Number", key: "irrd"},
        { title: "IRD Number", key:"ird"},
        { title: "Serial Number ", key: "serial_number" },
      ];

      securedAxiosInstance
        .get("/api/v1/warehouse/put_away/all_inventories", {
          params: {
            disposition: this.pickup_disposition,
            search: this.putaway_search,
            page: params["page"],
            per_page: params["size"],
          },
        })
        .then((response) => {
          this.table_data_pickup = response.data.inventories;
          this.totalPages = response.data.meta.total_pages;
          this.totalCount = response.data.meta.total_count;
          this.dispos_change = false;
          this.loading = false;
        })
        .catch((error) => this.$toast.error("Error in retrieving data"));
    },
    dialogSelectedItemPickup() {
      if (this.selected.length <= 0) {
        this.showAlert("warning", "Please Select Item First");
        return;
      }
      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.pickupaction = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.selctedItemsPickup = true;
      this.headers_pickup_sel = [
        { title: "", key: "customcheck", width: "3%" },
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
        { title: "Delete", key: "action" },
      ];
      this.table_data_pickup_sel = this.selected;
      this.inv_id = this.selected.map((inventory) => inventory.id);
      var dato = unique_array[0];
      this.dc_id = dato.toString();
    },
    assignExecutivePickup() {
      this.number = 0;
      this.assignExecutivePopupPickup = true;
      this.requestReasonPickup = "";
      this.assignToPickup = [];
      this.pickupReason = "";
      (this.requestType = ""),
        this.$httpSecured
          .get("api/v1/warehouse/put_away/request_reasons", {
            params: { distribution_center_id: this.dc_id, status:'pick_up'  },
          })
          .then((response) => {
            if (response.data) {
              this.request_reason_pickup = response.data.put_away_reasons;
              this.reason = response.data.pick_up_reasons;
              this.request_Type = response.data.request_types;
              this.users_pickup = response.data.users;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
    },
    assignExSubmitPickup() {
      this.number++;
      // const formData = new FormData();
      this.$httpSecured
        .post("api/v1/warehouse/put_requests", {
          put_request: {
            request_type: "pick_up",
            pick_up_reason: this.requestReasonPickup,
            disposition: this.pickup_disposition,
            distribution_center_id: this.dc_id,
            assignee_ids: this.assignToPickup,
            inventory_ids: this.inv_id,
          },
        })
        .then((response) => {
          if (response.data) {
            this.selctedItemsPickup = false;
            this.assignExecutivePopupPickup = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.pickupaction = false;
            }
            this.successDialogInward = true;
            this.successMsg = response.data.message;
            this.showAlert("success", "Successfully request created");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.number = 0;
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },

    cancelRequestDialogOpen() {
      this.cancelRequestPopup = true;
    },

    cancelRequestSubmit() {
      this.$httpSecured
        .post("api/v1/warehouse/put_requests/cancel_request", {
          request_ids: this.selected.map((x) => x.id),
        })
        .then((response) => {
          if (response.data) {
            this.cancelRequestPopup = false;
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.requestTracListSelected = false;
            }
            this.showAlert("success", "Requests cancelled successfully");
            this.loadData(this.active_tab);
            this.active_tab == "Request Tracker";
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },

    // changeReasonPickup(){
    //             if(this.requestType === 'pick_up'){
    //               this.reason = this.pickup_reason;
    //             }else{
    //               this.reason = this.request_reason_pickup;
    //             }
    //           }

    changeAssignmentFunc() {
      if (this.selected.length <= 0) {
        this.showAlert("warning", "Please Select Item First");
        return;
      }

      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      if (unique_array.length > 1) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.requestTracListSelected = false;
        }
        this.showAlert(
          "error",
          "Please select the items from the same Location!",
        );
        return;
      }
      this.assign_user = "CHANGE ASSIGN";
      this.changeAssignmentPopup = true;
      this.change_assignment = [];
      this.number = 0;
      var dato = unique_array[0];
      this.dc_id = dato.toString();
      this.inv_id = this.selected.map((inventory) => inventory.id);
      this.$httpSecured
        .get("/api/v1/warehouse/put_requests/location_users", {
          params: { distribution_center_id: this.dc_id },
        })
        .then((response) => {
          if (response.data) {
            this.change_assignment_items = response.data.users;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    changeAssignmentEditFunc() {
      this.changeAssignmentEditPopup = true;
      var dc = this.selected.map((x) => x.distribution_center_id);
      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      dc = dc.filter(function (element) {
        return element !== undefined;
      });

      var unique_array = dc.filter((item, index, self) => unique(item, index, self));
      var dato = unique_array[0];
      this.dc_id = dato.toString();
      this.$httpSecured
        .get("/api/v1/warehouse/put_requests/location_users", {
          params: { distribution_center_id: this.dc_id },
        })
        .then((response) => {
          if (response.data) {
            this.change_assignment_edit_items = response.data.users;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    changeAssignConfirm() {
      this.number++;
      // const formData = new FormData();
      this.$httpSecured
        .post("/api/v1/warehouse/put_requests/update_assignee", {
          request_ids: this.inv_id,
          assignee_ids: this.change_assignment,
        })
        .then((response) => {
          if (response.data) {
            this.changeAssignmentPopup = false;
            this.selected = [];
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.requestTracListSelected = false;
            }
            this.showAlert("success", "Successfully updated");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.number = 0;
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },
    editRequestDialog() {
      this.number = 0;
      this.request_sl_id = this.selected.map((x) => x.id);
      var req_id_1 = this.selected.map((x) => x.request_id);
      let value = req_id_1[0];
      this.req_id = value;
      // const unique = (value, index, self) => {
      //   return self.indexOf(value) === index;
      // };
      console.log(this.selected , "::: this.selected");
      if (this.selected.length == 1) {
        this.editRequestPopup = true;
        this.assign_user = "EDIT REQUEST";
      } else {
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.selected = [];
          this.requestTracListSelected = false;
        }
        this.showAlert("error", "Select only One items");
        return;
      }

      this.loading = true;
      this.edit_req_headers = [
        { title: "", key: "customcheck", width: "3%" },
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Delete", key: "action" },
      ];
      securedAxiosInstance
        .get("api/v1/warehouse/put_requests/" + this.request_sl_id)
        .then((response) => {
          this.edit_req_table_data = response.data.put_request.request_items;
          this.change_assignment_item_edit =
            response.data.put_request.assignee_ids;
          this.update_inv_id = this.edit_req_table_data.map(
            (x) => x.inventory_id,
          );
          this.change_assignment = response.data.put_request.assignee_id;
          this.loading = false;
        })
        .catch((error) => this.$toast.error("Error in retrieving data"));
    },
    deleteRequestTrack() {
      this.editRequestPopup = false;
      if (this.selected.length > 0) {
        this.selected = [];
        var input = document.querySelectorAll(".checkbox");
        for (var i = 0; i < input.length; i++) {
          input[i].checked = false;
          this.requestTracListSelected = false;
        }
      }
    },
    editrequestSave() {
      this.number++;
      // const formData = new FormData();
      this.$httpSecured
        .put("api/v1/warehouse/put_requests/" + this.request_sl_id, {
          put_request: {
            assignee_ids: this.change_assignment_item_edit,
            inventory_ids: this.update_inv_id,
          },
        })
        .then((response) => {
          if (response.data) {
            this.editRequestPopup = false;
            this.inv_id = "";
            this.change_assignment = "";
            this.change_assignment_item_edit = "";
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.requestTracListSelected = false;
            }
            this.showAlert(
              "success",
              `Request ${this.req_id} has been updated successfully.`,
            );
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "error.response.data.error");
          this.number = 0;
          this.loading = false;
        });
    },
    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },
    handlePageChange(value) {
      this.page = value;
      if(this.applied_filter === true){
        this.applyFilterFunc();
      }else{
        this.dispos_change = true;
        this.loadData(this.active_tab);
      }
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      if(this.applied_filter === true){
         this.applyFilterFunc();
      }else{
        this.dispos_change = true;
        this.loadData(this.active_tab)
      }
      
    },
    deleteReqTracker() {
      this.$httpSecured
        .delete("api/v1/warehouse/put_requests/" + this.request_sl_id)
        .then((response) => {
          if (response.data) {
            this.editRequestPopup = false;
            this.inv_id = "";
            this.change_assignment = "";
            var input = document.querySelectorAll(".checkbox");
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.requestTracListSelected = false;
            }
            this.showAlert("success", "Successfully deleted");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },
    addMoreItemsReqTrack() {
      this.addMoreItemsPopup = true;
      this.loading = true;

      const params = this.getRequestParams(this.page, this.pageSize);
      this.add_items_headers = [
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        {
          title: "Article Description",
          key: "item_description",
          width: "15%",
        },
        { title: "Grade", key: "grade" },
        { title: "Sub Location", key: "sub_location" },
        { title: "Site Location", key: "distribution_center" },
      ];
      securedAxiosInstance
        .get(
          "/api/v1/warehouse/put_requests/" + this.request_sl_id + "/add_items",
          {
            params: {
              search: this.add_item_search,
              page: params["page"],
              per_page: params["size"],
            },
          },
        )
        .then((response) => {
          this.add_items_table_data = response.data.inventories;
          this.totalPages = response.data.meta.total_pages;
          this.totalCount = response.data.meta.total_count;
          this.loading = false;
          this.add_item_search = "";
        })
        .catch((error) => this.$toast.error("Error in retrieving data"));
    },

    addButton() {
      this.addMoreItemsPopup = false;
      const newItems = this.selected_add.filter((item) => {
        return !this.edit_req_table_data.some((existingItem) => {
          return existingItem.id === item.id;
        });
      });
      newItems.forEach((item) => {
        if (
          !this.edit_req_table_data.some(
            (existingItem) => existingItem.id === item.id,
          )
        ) {
          this.edit_req_table_data.push(item);
        } else {
          this.showAlert(`Item with ID ${item.id} is already added.`);
        }
      });
      const newIds = newItems.map((item) => item.id);
      this.update_inv_id = [...this.update_inv_id, ...newIds];
      this.selected_add = [];
    },
    searchfiledClear(active_tab) {
      if (this.active_tab == "Open Putaway") {
        this.putaway_search = "";
      }
    },
    linkPopupInReqTracker(item) {
      this.number = 0;
      this.request_sl_id = item.id;
      let value = item.request_id;
      this.req_id = value;
      this.reqTrackStatus = item.status;
      this.selected_manf = [];
      this.itemLinkPopup = true;
      this.loading = true;
      this.edit_req_headers = [
        {
          title: "Tag ID",
          key: "tag_number",
          align: "start",
          sortable: false,
          width: "12%",
        },
        { title: "Category", key: "category" },
        { title: "Article Id", key: "sku_code" },
        { title: "Article Description", key: "item_description" },
        { title: "Status", key: "status" },
        { title: "Sub Location", key: "sub_location" },
      ];
      securedAxiosInstance
        .get("api/v1/warehouse/put_requests/" + this.request_sl_id)
        .then((response) => {
          this.edit_req_table_data = response.data.put_request.request_items;
          this.update_inv_id = this.edit_req_table_data.map(
            (x) => x.inventory_id,
          );
          this.change_assignment = response.data.put_request.assignee_id;
          this.loading = false;
        })
        .catch((error) => this.$toast.error("Error in retrieving data"));
    },
    manfSubmit() {
      this.number++;
      const formData = new FormData();
      var vendorLists = [];
      for (var i = 0; i < this.selected_manf.length; i++) {
        vendorLists.push(this.selected_manf[i].id);
      }
      var vendorListsString = JSON.stringify(vendorLists);
      formData.append("item_ids", vendorListsString);
      this.$httpSecured
        .put(
          `api/v1/warehouse/put_requests/${this.request_sl_id}/mark_as_not_found`,
          {
            item_ids: vendorLists,
          },
        )
        .then((response) => {
          if (response.data) {
            this.itemLinkPopup = false;
            this.successmessage = response.data.message;
            this.rejectsussesspopup = true;
            this.selected_manf = [];
            this.showAlert("success", "Successfully updated");
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.number = 0;
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;
        });
    },
    afterClickOkLoadData() {
      this.rejectsussesspopup = false;
      this.selected = [];
      this.loadData(this.active_tab);
    },
    handleSelection() {
      this.assignData = this.assignTo;
      // Handle any additional logic when items are selected
    },
    getItemName(itemId) {
      const item = this.inward_users.find((item) => item.id === itemId);
      return item ? item.username : "";
    },
    removeItem(itemId) {
      // Remove the item from selectedItems
      const index = this.assignData.indexOf(itemId);
      if (index > -1) {
        this.assignData.splice(index, 1);
      }
    },
    selectAll() {
      if (this.active_tab == "Inward Putaway") {
        this.assignTo = this.inward_users.map((user) => user.id);
      }
      if (this.active_tab == "Open Putaway") {
        this.assignToOpen = this.inward_users_open.map((user) => user.id);
      }
      if (this.active_tab == "Pick Up") {
        this.assignToPickup = this.users_pickup.map((user) => user.id);
      }
      if (this.active_tab == "Request Tracker") {
        this.change_assignment = this.change_assignment_items.map(
          (user) => user.id,
        );
      }
    },
    selectAllForEdid() {
      if (this.active_tab == "Request Tracker") {
        this.change_assignment_item_edit =
          this.change_assignment_edit_items.map((user) => user.id);
      }
    },
  },
};
</script>
<style scoped>
.btn-color-text {
  color: #0357d0 !important;
}

.btn-color-red {
  color: #ec0101 !important;
}

.selected-items {
  margin-bottom: -10px !important;
  color: white !important;
}

.margin-right {
  margin-right: 0;
}

.filter-position {
  position: absolute !important;
  top: 236px !important;
  right: 0px !important;
}

.v-dialog-filter {
  position: absolute !important;
  top: 236px !important;
  right: 0 !important;
}

.cancel-color {
  background-color: #ffffff;
  color: #0000ff;
  border: 1px solid #0000ff;
}

.submit-color {
  background-color: #0000ff;
  color: #ffffff !important;
  border: 1px solid #0000ff;
}

.my-custom-dialog {
  align-self: flex-end;
}

.margin-10 {
  margin-top: -32px;
  margin-right: 13px;
  justify-content: center !important;
}
.tool_search {
  height: 65px;
}
.v-dialog:has(.filter-putaway) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
.btn-groop {
  position: relative;
  top: -44px;
  margin-right: 10px;
}
.v-dialog > .v-card > :has(.v-card__title) {
  overflow-wrap: break-word !important;
}

.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}
.btn-cancel {
  border: 1px solid #2196f3;
  color: #2196f3;
}

.rule-type_option {
  border: 1px solid #000000;
  padding: 4px 8px;
  border-radius: 5px;
  margin: 1px 2px;
}
.selected_rule_box {
  display: flex;
  flex-wrap: wrap;
}
.select-all-link {
  color: #1561b1;
  margin-top: -17px;
  margin-left: 233px;
  font-weight: 700;
  font-size: 12px;
}
.v-field-label{
  color:blue !important;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 300px) !important;
}
.v-data-table.index-table {
  height: calc(var(--vh, 1vh) * 100 - 300px) !important;
}
.v-data-table.addmoreitemstable {
  height: calc(var(--vh, 1vh) * 100 - 130px) !important;
}
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
.filter_ui{
    margin-left: 28px !important;
    margin-top: 24px !important;
 }
 :deep(.height-auto .v-input__control){
  height:52px !important;
 }
</style>
